var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"slide-proportion-3-2"},[_c('div',{staticClass:"right-block-positioner"},[_c('div',{staticClass:"right-block__content"},[_c('circle-wrapper',[_c('video-player-preview',{attrs:{"poster-src":_vm.posterSrc},on:{"click":_vm.playVideo}})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad518fa2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SlideFragment/Slides/Fact3/Right.vue
// module id = 137
// module chunks = 0